import { createSlice } from '@reduxjs/toolkit'
import { Training, TrainingState } from './type'

const trainingState: TrainingState = {
    trainingList: [],
    totalCount: 0,
    pageSize: 2,
}

const trainingSlice = createSlice({
    name: 'admintraining',
    initialState: trainingState,
    reducers: {
        programlist: (state, action) => {
            state.trainingList = action.payload.data
            state.totalCount = action.payload.totalCount
            state.pageSize = action.payload.pageSize
        },
        addprogram: (state, action) => {
            const data = action.payload
            const program = {
                id: action.payload.id,
                title: data.payload.title,
            }
            state.trainingList.unshift(program)
        },
        editprogram: (state, action) => {
            const data = action.payload
            const index = state.trainingList.findIndex(
                (training: any) => training.id === data.payload.programId
            )
            state.trainingList[index] = {
                id: data.payload.programId,
                title: data.payload.title,
            }
        },
        deleteprogram: (state, action) => {
            state.trainingList = state.trainingList.filter(
                (brand: Training) => brand.id !== action.payload
            )
        },
    },
})

export default trainingSlice.reducer

export const { programlist, editprogram, addprogram, deleteprogram } =
    trainingSlice.actions
